import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function CallingTabCompletedMessage() {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        flexGrow: 1,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem',
      }}
    >
      <Typography sx={{ textAlign: 'center' }}>
        You have completed your list.
        <br />
        To see if there are more available contacts in your list, return to the{' '}
        <strong>Details</strong> view and remove any filter(s) you have applied.
        <br />
        To review contacted and skipped records, use the <strong>Show completed</strong> checkbox.
      </Typography>
    </Box>
  );
}
